import piexif from 'piexifjs';

/**
 * Fix image orientation using EXIF data and return a Blob URL.
 * @param {File|Blob} file
 * @returns {Promise<string>} Blob URL of fixed image
 */
export async function fixImageOrientation(file) {
  const arrayBuffer = await file.arrayBuffer();
  const dataView = new DataView(arrayBuffer);
  const binary = new Uint8Array(arrayBuffer).reduce((acc, byte) => acc + String.fromCharCode(byte), '');
  const exifObj = piexif.load(binary);
  const orientation = exifObj['0th'][piexif.ImageIFD.Orientation] || 1;
  if (orientation === 1) return URL.createObjectURL(file);
  const img = await createImageBitmap(file);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  if (orientation > 4) {
    canvas.width = img.height;
    canvas.height = img.width;
  } else {
    canvas.width = img.width;
    canvas.height = img.height;
  }
  switch (orientation) {
    case 2: ctx.transform(-1, 0, 0, 1, canvas.width, 0); break;
    case 3: ctx.transform(-1, 0, 0, -1, canvas.width, canvas.height); break;
    case 4: ctx.transform(1, 0, 0, -1, 0, canvas.height); break;
    case 5: ctx.transform(0, 1, 1, 0, 0, 0); break;
    case 6: ctx.transform(0, 1, -1, 0, canvas.height, 0); break;
    case 7: ctx.transform(0, -1, -1, 0, canvas.height, canvas.width); break;
    case 8: ctx.transform(0, -1, 1, 0, 0, canvas.width); break;
    default: break;
  }
  ctx.drawImage(img, 0, 0);
  return new Promise((resolve) => {
    canvas.toBlob((blob) => {
      resolve(URL.createObjectURL(blob));
    }, file.type);
  });
}
